<template>
    <div style="white-space: nowrap;" class="text-xs-right" v-if="!edit">
        <v-icon color="orange" small class="mr-2" @click="toggleEdit" v-if="$root.user.permissions.change_project">
            edit
        </v-icon>
        <span class="budgeted-value">
            <span v-if="value">{{ formatMoney(value) }}</span>
            <span v-else>&ndash;</span>
        </span>
    </div>
    <div v-else>
        <div class="budgeted-value-edit elevation-5">
            <v-text-field v-model="internalValue" filled :label="label" type="number" step="0.1"
                          hide-details/>
            <v-progress-linear indeterminate class="ma-0" v-if="loading"/>

            <v-card-actions>
                <v-btn text @click="save" color="green">
                    <v-icon left>save</v-icon>
                    Lagre
                </v-btn>
                <v-spacer/>
                <v-btn icon @click="toggleEdit">
                    <v-icon color="red">close</v-icon>
                </v-btn>
            </v-card-actions>
        </div>
    </div>
</template>

<script>
    import {formatMoney} from "../../helpers";

    export default {
        props: {
            project: Object,
            field: String,
            label: {
                type: String,
                default: 'Budsjettert'
            }
        },
        data() {
            return {
                edit: false,
                internalValue: this.value,
                loading: false
            }
        },
        created() {
            this.internalValue = this.value;
        },
        methods: {
            formatMoney,
            toggleEdit() {
                this.edit = !this.edit;
            },
            save() {
                this.loading = true;
                let data = {};
                let fieldKey = `budget_${this.field}`;
                data[fieldKey] = this.internalValue;
                return this.$http.patch(`projects/${this.project.id}/`, data).then(response => {
                    this.project[fieldKey] = response.data[fieldKey];
                    this.toggleEdit();
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        watch: {
            value() {
                console.log('upd val')
                this.internalValue = this.value;
            }
        },

        computed: {
            value() {
                return this.project[`budget_${this.field}`];
            }
        }
    }
</script>

<style>
    .budgeted-value .v-icon {
        cursor: pointer;
        transition: all 0.25s;
    }

    .budgeted-value .v-icon:hover {
        transform: translateY(-2px) scale(1.1);
        color: #000 !important;
    }

    .budgeted-value-edit {
        position: absolute;
        margin-top: -19px !important;
        border-radius: 3px;
        background-color: #fff;
    }
</style>